import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/auth`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  // Ne pas écraser un header Authorization déjà défini (ex: tempToken 2FA)
  if (!config.headers.Authorization) {
    const token = localStorage.getItem('finance_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const authApi = {
  login: (username, password) => api.post('/login', { username, password }),
  setup2fa: (tempToken) => api.get('/2fa/setup', { headers: { Authorization: `Bearer ${tempToken}` } }),
  enable2fa: (tempToken, code) => api.post('/2fa/enable', { code }, { headers: { Authorization: `Bearer ${tempToken}` } }),
  verify2fa: (tempToken, code) => api.post('/verify-2fa', { code }, { headers: { Authorization: `Bearer ${tempToken}` } }),
  me: () => api.get('/me'),
  changePassword: (currentPassword, newPassword) => api.put('/change-password', { currentPassword, newPassword }),
  getUsers: () => api.get('/users'),
  createUser: (data) => api.post('/register', data),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
};

export default authApi;
